module.exports = __webpack_public_path__ + "static/img/1.78656e35.png";